<template>
  <v-container id="container" class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col>
        <v-card :loading="loading" :disabled="loading">
          <v-card-title>
            Profit List
          </v-card-title>
          <validation-observer ref="validationObserver">
            <v-card-text>
              <v-row>
                <v-col>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(sortition, index) in sortitions"
                      :key="index"
                    >
                      <v-expansion-panel-header
                        >{{ sortition.name }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col
                            v-for="(weekday, index) in weekdays"
                            :key="index"
                          >
                            <validation-provider
                              slim
                              mode="eager"
                              rules="required|integer|min_value:0|max_value:100"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="
                                  profits[sortition.id][weekday.attributes.id]
                                    .profit
                                "
                                maxlength="3"
                                dense
                                :error-messages="errors"
                                outlined
                                :label="weekday.attributes.name"
                              >
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn color="success" text @click="onSave">
                    <font-awesome-icon icon="save" class="mr-1">
                    </font-awesome-icon>
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </validation-observer>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContentLoader from "../../../mixins/ContentLoader.js";
import { getProfits, saveProfits } from "@/api/profit.api";
import keyBy from "lodash/keyBy.js";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import {
  integer,
  required,
  min_value,
  max_value
} from "vee-validate/dist/rules";

extend("integer", {
  ...integer,
  message: "Must be an integer"
});

extend("min_value", {
  ...min_value,
  message: "The minimum value is: {min}"
});

extend("max_value", {
  ...max_value,
  message: "The maximum value is: {max}"
});

extend("required", {
  ...required,
  message: "Cannot be blank."
});

export default {
  name: "ProfitIndex",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [ContentLoader],
  data() {
    return {
      date: "",
      profits: {},
      sortitions: [],
      weekdays: []
    };
  },
  async created() {
    this.$startLoading();
    try {
      await this.getProfits();
    } catch (e) {
      console.error(e);
    } finally {
      this.$finishedLoading();
    }
  },
  computed: {
    sortitionMap() {
      return keyBy(this.sortitions, "id");
    },
    weekdayMap() {
      return keyBy(this.weekdays, "id");
    }
  },
  methods: {
    async onSave() {
      const valid = await this.$refs.validationObserver.validate(),
        profits = Object.values(this.profits).flatMap(p => Object.values(p));
      if (valid) {
        saveProfits({ profits })
          .then(() => {
            this.$swal.fire({
              icon: "success",
              title: "The profits were saved successfully",
              timer: 2000,
              showConfirmButton: false
            });
          })
          .catch(error => {
            this.$swal.fire({
              icon: "error",
              title:
                "There was an error saving profits, refresh the page and try again.",
              timer: 2000,
              showConfirmButton: false
            });
            this.handleErrorResponse(this.$refs.validationObserver, error);
          });
      }
    },
    async getProfits() {
      try {
        const { data } = await getProfits(),
          { profits, sortitions, weekdays } = data;

        this.profits = profits;
        this.sortitions = sortitions;
        this.weekdays = weekdays;
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style scoped></style>
